<template>
    <div>
        <CList :pConfigList="ConfigList" :segurity="segurity">
            <template slot="bodyForm">
                <CLoader :pConfigLoad="ConfigLoad">
                    <template slot="BodyFormLoad">
                        <div class="container-fluid">
                            <form id="FormBancoImagen" role="form" method="post" autocomplete="off" onSubmit="return false">

                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                        <div class="avatar-upload">
                                            <div class="avatar-edit">
                                                <input type="file" @change="$uploadImagePreview($event,ValidElement, Array('Img','imagePreview'))" id="file" name="file" ref="fileImg" accept=".png, .jpg, .jpeg">
                                                <label for="file"></label>
                                            </div>
                                            <div class="avatar-preview">
                                                <div id="imagePreview" :style="'background-image: url('+RutaFile+objBancoImagen.Nomimagen+')'" :src="RutaFile+objBancoImagen.Nomimagen">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label for="Descripcion">Descripción</label>
										        <textarea v-model="objBancoImagen.Descripcion" class="form-control" id="Descripcion" placeholder="Ingresar Descripción" rows="3"></textarea>
										        <CValidation v-if="this.errorvalidacion.Descripcion" :Mensaje="'*'+errorvalidacion.Descripcion[0]"/>
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label for="DescripcionIng">Descripción en Inglés</label>
										        <textarea v-model="objBancoImagen.DescripcionIng" class="form-control" id="DescripcionIng" placeholder="Ingresar Descripción en Inglés" rows="3"></textarea>
										        <CValidation v-if="this.errorvalidacion.DescripcionIng" :Mensaje="'*'+errorvalidacion.DescripcionIng[0]"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                        <label for="Precio">Precio</label>
                                        <input type="text" v-model="objBancoImagen.Precio" @input="$number_decimal($event,objBancoImagen,'Precio');CalcularPrecios();" class="form-control" id="Precio" placeholder="Ingresar Precio" />
                                        <CValidation v-if="this.errorvalidacion.Precio" :Mensaje="'*'+errorvalidacion.Precio[0]"/>
                                    </div>

                                    <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                        <label for="TipoDisponibilidad">Tipo Disponibilidad</label>
                                        <select v-model="objBancoImagen.TipoDisponibilidad" class="form-control form-select" name="TipoDisponibilidad" id="TipoDisponibilidad">
                                            <option value="">Seleccione una opción</option>
                                            <option value="producible">Producible </option>
                                            <option value="no producible">No Producible</option>
                                            <option value="subarrendado">Subarrendado</option>
                                        </select>
                                        <CValidation v-if="this.errorvalidacion.TipoDisponibilidad" :Mensaje="'*'+errorvalidacion.TipoDisponibilidad[0]"/>
                                    </div>

                                    <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                        <label for="Stock">Pzs en Stock</label>
                                        <input type="text" v-model="objBancoImagen.Stock" @input="$onlyNums($event,objBancoImagen,'Stock');" class="form-control" id="Stock" placeholder="Ingresar Stock" />
                                        <CValidation v-if="this.errorvalidacion.Stock" :Mensaje="'*'+errorvalidacion.Stock[0]"/>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <div class="col-12 col-sm-12 col-md-1 col-lg-1">
                                        <label for="">Comisiones:</label>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                        <button class="btn btn-01" id="toggle-btn" @click="AbreModal" type="button">Seleccionar</button>
                                    </div>
                                </div>

                                <div v-if="objBancoImagen.ComisionesxBancoImagen.length>0" class="form-group row row-cols-lg-4">
                                    <div v-for="(lista,index) in objBancoImagen.ComisionesxBancoImagen" :key="index" class="col-lg-2">
                                        <label for="">Precio {{ lista.Cantidad+'%' }}</label>
                                        <input type="text" v-model="lista.Precio" @input="$number_decimal($event,lista,'Precio');CambiarPrecio(lista)" class="form-control">
                                        <CValidation v-if="errorvalidacion[lista.IdComision]" :Mensaje="'*'+errorvalidacion[lista.IdComision].Precio[0]"/>
                                    </div>
                                </div>

                                <CBtnSave :poBtnSave="oBtnSave" />

                            </form>
                        </div>
                    </template>
                </CLoader>
            </template>
        </CList>
        <CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSaveModal">
            <template slot="Form">
                <FormModal :poBtnSave="oBtnSaveModal" 
                :pComisiones="objBancoImagen.ComisionesxBancoImagen"
                :pComisionesLista="Comisiones"
                :pIdBancoImagen="objBancoImagen.IdBancoImagen"></FormModal>
            </template>
        </CModal>
    </div>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';

import FormModal from '@/views/catalogos/bancoImagen/ComisionesModal.vue';
const EmitEjecuta = 'seccionBancoImagen';
const EmitEjecuta2 = 'seccionComisionesxBanco';

export default {
    name: 'FormBancoImagen',
    props: ['Id'],
    components:{
        FormModal
    },
    data(){
        return{
            ConfigList:{
                Title: 'Formulario',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
                TypeBody: 'Form',
				TitleFirst: 'Galería',
				EmitSeccion: EmitEjecuta,
            },
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            ConfigModal:{
                ModalTitle: "Asignar Comisiones",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta2,
            },
			oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'galeriaImagen',
                EmitSeccion: EmitEjecuta,
            },
            oBtnSaveModal: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
                TxtBtnSave:'Asignar'
            },
            objBancoImagen: {
				IdBancoImagen: 0,
				Nomimagen: '',
				Descripcion: '',
				DescripcionIng: '',
				Precio: '',
				TipoDisponibilidad: '',
				Stock: '',
				IdCategoriaGaleria: 0,
				IdEmpresa: 0,
				IdSucursal: 0,
				ComisionesxBancoImagen: [],
                UrlImagen: '',
            },
            segurity: {},
            errorvalidacion: [],
            errorvalidacion2: [],
			Emit: EmitEjecuta,

            Comisiones:[],
            ValidElement: Configs.validImage3m,
            RutaFile: '',
            Img: null,
        }
    },
    methods :
    {
       	async Guardar()
        {
			let formData = new FormData();
            let Imagen = this.$refs.fileImg.files[0];

            if(Imagen === undefined && this.objBancoImagen.IdBancoImagen == 0){
                this.$toast.warning('Debe agregar una imagen');
                return false;
            }

			formData.set('IdBancoImagen', this.objBancoImagen.IdBancoImagen);
			formData.set('Nomimagen', this.objBancoImagen.Nomimagen);
			formData.set('Descripcion', this.objBancoImagen.Descripcion);
			formData.set('DescripcionIng', this.objBancoImagen.DescripcionIng);
			formData.set('Precio', this.objBancoImagen.Precio);
			formData.set('TipoDisponibilidad', this.objBancoImagen.TipoDisponibilidad);
			formData.set('Stock', this.objBancoImagen.Stock);
			formData.set('IdCategoriaGaleria', this.objBancoImagen.IdCategoriaGaleria);
            formData.set('TipoImagen','Galeria');
            formData.set('Comisiones',JSON.stringify(this.objBancoImagen.ComisionesxBancoImagen));
            formData.set('ImagenAntigua', this.objBancoImagen.Nomimagen);

			
			formData.append('Imagen',Imagen);
			
			this.errorvalidacion = [];
            this.errorvalidacion2 = [];
            this.oBtnSave.Toast = 0; 
            this.oBtnSave.DisableBtn = true;
			
			await this.$http.post('bancoImagenes', formData,{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((res)=>{
				this.EjecutaConExito(res);
			}).catch(err=>{   
				this.EjecutaConError(err);
			});
        },
		EjecutaConExito(res)
        {
            this.oBtnSave.DisableBtn = false;
            this.bus.$emit('RunAlerts_'+this.Emit,1);
            this.Regresar();
        },
        EjecutaConError(err)
        {
            this.oBtnSave.DisableBtn = false;
            if (err.response.data.id!==undefined) {
                this.objBancoImagen.IdBancoImagen=err.response.data.id;
            }
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.oBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "bancoImagenes/"+this.objBancoImagen.IdBancoImagen
            ).then((res) => {
                this.objBancoImagen.Descripcion = res.data.data.Descripcion;
                this.objBancoImagen.DescripcionIng = res.data.data.DescripcionIng;
                this.objBancoImagen.Precio = res.data.data.Precio;
                this.objBancoImagen.TipoDisponibilidad = res.data.data.TipoDisponibilidad;
                this.objBancoImagen.Stock = res.data.data.Stock;
                this.objBancoImagen.IdCategoriaGaleria = res.data.data.IdCategoriaGaleria;
                this.objBancoImagen.IdEmpresa = res.data.data.IdEmpresa;
                this.objBancoImagen.IdSucursal = res.data.data.IdSucursal;
                this.objBancoImagen.Nomimagen = res.data.data.Nomimagen;
                this.RutaFile = res.data.RutaFile;
            })
			.finally(()=>{
                this.RecuperarComisiones(this.objBancoImagen.IdBancoImagen);
            });
        },
        Limpiar()
        {
            this.objBancoImagen = {
				IdBancoImagen: 0,
				Nomimagen: '',
				Descripcion: '',
				DescripcionIng: '',
				Precio: '',
				TipoDisponibilidad: '',
				Stock: '',
				IdCategoriaGaleria: 0,
				IdEmpresa: 0,
				IdSucursal: 0,
				ComisionesxBancoImagen: [],
                UrlImagen: '',
				
            }
            this.errorvalidacion = [];
            this.errorvalidacion2 = [],
			this.Comisiones=[];
        },
        Regresar() {
            this.$router.push({name:this.oBtnSave.ReturnRoute});
        },
        // METODOS PROPIOS
        AbreModal(){
            this.bus.$emit('NewModal_'+this.ConfigModal.EmitSeccion,0,this.objBancoImagen);
            this.bus.$emit('Recovery_'+this.ConfigModal.EmitSeccion,0);
        },
        RecuperarComisiones(IdBancoImagen){
			this.$http.get("/comisionesxbancoimagen",{
				params:{
					IdBancoImagen:IdBancoImagen
				}
			}).then((res)=>{
				this.objBancoImagen.ComisionesxBancoImagen=res.data.data;
			}).finally(()=>{
				this.ConfigLoad.ShowLoader=false;
			})
		},
        CambiarPrecio(item){
            let index=this.Comisiones.findIndex((element)=>element.IdComision==item.IdComision);
            this.Comisiones[index].Precio=item.Precio;
        },
        CalcularPrecios(){
            if (this.objBancoImagen.ComisionesxBancoImagen.length>0) {
                this.objBancoImagen.ComisionesxBancoImagen.forEach((element)=>{
                    element.Precio = Number(this.objBancoImagen.Precio)+(Number(this.objBancoImagen.Precio)*element.Cantidad)/100;
                })
            }
        }
    },
    created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;

        this.bus.$off('EmitReturn');
        this.bus.$off('Save_'+this.Emit);

        this.bus.$off('TraerComisionesSeleccionadas');
    },
    mounted()
    {
		this.oBtnSave.DisableBtn = false;
        this.Limpiar();

        if(this.Id!='') 
        {
            this.objBancoImagen.IdBancoImagen = this.Id;
            this.Recuperar();
            // this.RecuperarComisiones(this.objBancoImagen.IdBancoImagen);
        }
		else
		{
			this.ConfigLoad.ShowLoader = false;
		}

        this.bus.$on('Save_'+this.ConfigList.EmitSeccion,()=>
        {
            let Categ = JSON.parse(sessionStorage.getItem('objCategoriaGaleria'));
            this.objBancoImagen.IdCategoriaGaleria = Categ.IdCategoriaGaleria;
            this.Guardar();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });

        this.bus.$on('TraerComisionesSeleccionadas',(ComisionesSeleccionadas,ListaComisiones)=>{
            this.objBancoImagen.ComisionesxBancoImagen = ComisionesSeleccionadas;
            this.Comisiones = ListaComisiones;
            if (this.objBancoImagen.Precio!="") {
                this.objBancoImagen.ComisionesxBancoImagen.forEach(element => {
                    element.Precio = parseFloat(this.objBancoImagen.Precio)+(parseFloat(this.objBancoImagen.Precio)*element.Cantidad)/100;
                });
            }
        });

    }
}
</script>

<style>

</style>